import { useForm } from 'react-hook-form'
import { Button } from '@/components/ui/button'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { TextInput } from '@/components/atoms/inputs'
import { Spinner } from '@/components/ui/spinner'

interface ChangePasswordDialogProps {
    open: boolean
    closeDialog: () => void
    onUpdate: (data: any) => void
    loading?: boolean
}

export const ChangePasswordDialog = ({
    open,
    closeDialog,
    onUpdate,
    loading = false,
}: ChangePasswordDialogProps) => {
    const form = useForm({
        defaultValues: {
            old_password: '',
            new_password: '',
            confirm_password: '',
        },
    })

    const {
        handleSubmit,
        reset,
        control,
        watch,
        formState: { errors },
    } = form

    const onSubmit = async (data: any) => {
        onUpdate(data)
    }

    const newPassword = watch('new_password')

    return (
        <Dialog open={open} onOpenChange={(val) => {
            if (!val) {
                reset()
                closeDialog()
            }
        }}>
            <DialogContent size="sm">
                <DialogHeader>
                    <DialogTitle>Change password</DialogTitle>
                    <DialogDescription>Enter your current password, then choose a new one.</DialogDescription>
                </DialogHeader>

                <div className="space-y-4">
                    <TextInput
                        control={control}
                        name="old_password"
                        label="Current password"
                        type="password"
                        rules={{ required: 'Old password is required' }}
                        errors={errors}
                    />

                    <TextInput
                        control={control}
                        name="new_password"
                        label="New password"
                        type="password"
                        rules={{
                            required: 'New password is required',
                            minLength: { value: 6, message: 'Password must be at least 6 characters' }
                        }}
                        errors={errors}
                    />

                    <TextInput
                        control={control}
                        name="confirm_password"
                        label="Confirm new password"
                        type="password"
                        rules={{
                            required: 'Confirm password is required',
                            validate: (value) => value === newPassword || 'Passwords do not match'
                        }}
                        errors={errors}
                    />
                </div>

                <DialogFooter>
                    <Button type="button" variant="outline" onClick={closeDialog} disabled={loading}>
                        Cancel
                    </Button>
                    <Button type="button" onClick={handleSubmit(onSubmit)} disabled={loading}>
                        {loading && <Spinner />}
                        Change password
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}
